export interface GetShelfTypeConversionInfoRequest {
  collectionType: string
  mark: string
  ndc: string
  book: string
  sub: string
}

export function GetShelfTypeConversionInfoRequestToJSON(
  value: GetShelfTypeConversionInfoRequest
): any {
  return {
    collection_type: value.collectionType || undefined,
    mark: value.mark || undefined,
    ndc: value.ndc || undefined,
    book: value.book || undefined,
    sub: value.sub || undefined
  }
}
